import * as React from 'react';

import {Card} from 'shells/card/card';
import {FeatureStatusCard} from 'shells/card/feature-status-card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';
import {SectionLabel} from 'shells/typography/section-label';

import type {GetTrackingSnippetPageFeatures_trackingSnippetPageFeatures as Features} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {getIcon, getHtmlPath, getTitle, getDescription, getStatusBadge} from './consts';
import {TrackingSnippetFeaturesLoadingState} from './tracking-snippet-features-loading-state';

type Props = {
    features: Features[];
};

export function TrackingSnippetFeatures(props: Props) {
    return (
        <Card
            hasBorder={true}
            hasShadow={true}
            fitContent={false}
            fitHeight={true}
            overflowVisible={true}
        >
            <div className='flex flex-dir-col pad-32'>
                <Body size='large' isBold={true} color='dark'>
                    How Nutshell’s tracking snippet works
                </Body>
                <div className='pt-16 pb-8'>
                    <SectionLabel noBottomBorder={true} noBottomMargin={true}>
                        MARKETING
                    </SectionLabel>
                </div>
                <StackLegacy spacing={12}>
                    {props.features.length === 0 ? (
                        <TrackingSnippetFeaturesLoadingState />
                    ) : (
                        props.features.map((feature) => {
                            const tertiaryText =
                                feature.status === 'NOT_CONNECTED'
                                    ? 'No snippet detected'
                                    : feature.statusText;

                            return (
                                <div key={feature.key}>
                                    {feature.key === 'chat' && (
                                        <div className='pt-16 pb-8'>
                                            <SectionLabel
                                                noBottomBorder={true}
                                                noBottomMargin={true}
                                            >
                                                ENGAGEMENT
                                            </SectionLabel>
                                        </div>
                                    )}
                                    <FeatureStatusCard
                                        onClick={() => {
                                            appHistory.push(getHtmlPath(feature.key));
                                        }}
                                        key={feature.key}
                                        icon={getIcon(feature.key)}
                                        title={getTitle(feature.key)}
                                        subtitle={
                                            <Body size='small' color='dark'>
                                                {getDescription(feature.key)}
                                            </Body>
                                        }
                                        tertiaryData={
                                            <Body size='small' color='light'>
                                                {tertiaryText}
                                            </Body>
                                        }
                                        statusBadge={getStatusBadge(feature.status)}
                                    />
                                </div>
                            );
                        })
                    )}
                </StackLegacy>
            </div>
        </Card>
    );
}
